import axios, { AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';

// 创建axios实例
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 获取当前语言设置，映射到服务器端支持的语言
const getAcceptLanguage = (): string => {
  const locale = localStorage.getItem('locale') || 'zh-TW';
  // 映射前端语言到HTTP Accept-Language格式
  const localeMap: Record<string, string> = {
    'zh-TW': 'zh-TW',
    'zh-CN': 'zh-CN',
    'en': 'en-US'
  };
  return localeMap[locale] || 'zh-TW';
};

// 请求拦截器 - 添加认证token和语言header
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 添加Accept-Language header
    config.headers['Accept-Language'] = getAcceptLanguage();
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Token过期或无效，清除本地存储
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // 触发认证状态变化事件，通知所有组件更新
      window.dispatchEvent(new Event('auth-changed'));
      
      // 触发登录模态框显示事件，而不是跳转页面
      const event = new CustomEvent('showLoginModal', { 
        detail: { callback: null } 
      });
      window.dispatchEvent(event);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
